// resources/js/Pages/DanaPirikaraRequests.jsx (or wherever Gilanpasa lives)
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import Swal from "sweetalert2";
import RequestPageMUI from "./RequestPageMUI";
import apiClient from "@/api/client";

const DanaPirikaraRequests = () => {
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [approveData, setApproveData] = useState({ reason: "" });
  const [submitting, setSubmitting] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [longTextDialog, setLongTextDialog] = useState({ open: false, value: "" });

  // Called by RequestPageMUI when "Approve" is clicked in the DataGrid
  const handleApprove = (row) => {
    setCurrentRow(row);
    setApproveData({ reason: "" });
    setApproveDialogOpen(true);
  };

  const handleApproveSubmit = async () => {
    const { reason } = approveData;
    if (!reason) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Reason is required.",
        confirmButtonColor: "#c49b36",
      });
      return;
    }
    setSubmitting(true);
    try {
      const response = await apiClient.put(
        `/update-pirikara-requests/${currentRow.id}/status`,
        { status: "Approved", status_reason: reason }
      );
      setApproveDialogOpen(false);                       // ← close FIRST
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Request approved successfully.",
        confirmButtonColor: "#c49b36",
      });
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      setApproveDialogOpen(false);                       // ← close FIRST
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || error.message,
        confirmButtonColor: "#c49b36",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleCellClick = (row, field) => {
    if (field === "pirikara_type" && row.pirikara_type) {
        setLongTextDialog({
        open: true,
        value: String(row.pirikara_type),
        });
    }
  };

  return (
    <>
      <RequestPageMUI
        key={refreshKey}
        title="Pirikara Requests"
        fetchUrl="/get-pirikara-requests"
        editEndpoint="update-pirikara-requests"
        deleteEndpoint="delete-pirikara-requests"
        statusEndpoint="update-pirikara-requests"
        dateFields={["created_at", "updated_at"]}
        hiddenFields={["ip_address"]}
        onApprove={handleApprove}
        onCellClick={handleCellClick}
      />

      {/* Approval Dialog (no monks_count field for Pirikara) */}
      <Dialog
        open={approveDialogOpen}
        onClose={() => !submitting && setApproveDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Approve Pirikara Request</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Reference: {currentRow?.id}
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              label="Reason / Message"
              multiline
              rows={3}
              fullWidth
              value={approveData.reason}
              onChange={(e) =>
                setApproveData({ ...approveData, reason: e.target.value })
              }
              required
              placeholder="E.g., Approved by coordinator, notes..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setApproveDialogOpen(false)}
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleApproveSubmit}
            variant="contained"
            color="success"
            disabled={submitting}
          >
            {submitting ? <CircularProgress size={24} /> : "Confirm Approval"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={longTextDialog.open}
        onClose={() => setLongTextDialog({ open: false, value: "" })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Pirikara Type</DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              lineHeight: 1.5,
              fontSize: "0.95rem",
              maxHeight: "60vh",
              overflowY: "auto",
            }}
          >
            {longTextDialog.value}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLongTextDialog({ open: false, value: "" })}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DanaPirikaraRequests;